export const getFooterCategoryLabels = (abbreviation: string) => {
  switch (abbreviation) {
    case 'ma':
      return {
        '/erotic-films': 'Erotic Films',
        '/galleries': 'Nude Photos',
        '/models': 'Nude Models',
      };
    default:
      return {
        '/erotic-films': 'Original Films',
        '/galleries': 'High Resolution Photos',
        '/models': 'Exclusive Models',
      };
  }
};
